<template>
  <div class="main-template">
    <!-- Use the component in the right place of the template -->

    <d-table
      :data_object="data_object"
      :getFreshData="true"
      :rowClick="rowClick"
      :key="tableKey"
      v-bind="vBind"
      :onDataReceived="onDataReceived"
      :editedItemTitle="editedItemTitle"
      v-if="tableReady"
      :itemsPerPage="50"
    />
  </div>
</template>

<script>
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
Vue.use(VueAxios, axios);
export default {
  // specify TiptapVuetify component in "components"
  components: {
    DTable: () => import("../components/Table.vue"),
  },
  props: {
    parentModel: [Object, Array],
  },
  data() {
    return {
      isHost: false,
      data_object: {
        object_name: "v_document",
        object_name_to_update: "document",
        schema_name: "document",

        all_records: true,
        additional_data: [
          {
            obj_name: "company",
          },
        ],
      },
      tableKey: 0,
      tableReady: false,
      editedItemTitle: ["document_name"],
      vBind: {
        alwaysUpdate: true,
        getFreshData: true,
        fields_excluded: ["body"],

        // expandedProperties: ["body"],
        defaultModel: {
          service_type: [],
          body: "",
          category: "shipment",

          type: this.$route.params.type,
        },
        hasSearch: true,
        table_title: "Documents",
        newItemTitle: "Add Document",
        addButtonCaption: "New Document",
        editable: [],
        editRow: true,

        // expandable: true,
      },
    };
  },
  mounted() {
    var that = this;
    this.isHost = this.$root.isHost;
    if (this.isHost) {
      this.data_object.object_name = "document";
      this.vBind.defaultModel.category = "my_customers";
    }
    var type = this.$route.params.type;
    var qry = {};
    if (!this.isHost) {
      if (type == "document") {
        qry = { type: this.$route.params.type };
        this.vBind.defaultModel.document_type = "invoice";
        this.vBind.defaultModel.category = "v_agent";
      } else {
        qry = {
          $or: [
            { type: this.$route.params.type },
            { type: { $exists: false } },
          ],
        };
      }
    }

    this.data_object.qry = qry;
    this.tableReady = true;
  },
  methods: {
    rowClick: function(item) {
      console.log(item);
    },
    onDataReceived(d) {
      if (this.isHost) {
        return d;
      }
      var that = this;
      // console.log(d);
      d.schema.properties.category["v-bind"].items =
        d.schema.properties.category["v-bind"][
          this.$route.params.type + "_items"
        ];
      if (d.table) {
        d.table.forEach((r) => {
          if (!r.company) {
            r.company = d.additional_model.company[0]._id;
          }
          if (!r.type) {
            r.type = that.$route.params.type;
          }
          if (!r.send_to) {
            r.send_to = ["customer"];
          }
        });
      }

      return d;
    },
  },
};
</script>
